// extracted by mini-css-extract-plugin
export var audioPlayer = "_ok-0";